import { render, staticRenderFns } from "./ManageBankBranch.vue?vue&type=template&id=ea7120a2&"
import script from "./ManageBankBranch.vue?vue&type=script&lang=js&"
export * from "./ManageBankBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports